/* Selet v92 (02/10): video da galeria da PDP (ate 720p) so carrega quando entra na tela.
   <video class="selet-lazy-video" data-src preload="none" poster> -> recebe src perto da tela; toca sozinho
   (mudo) se o tema pedir autoplay (data-selet-autoplay) e pausa ao sair da tela. */
(function () {
  function hyd(v) {
    if (v.__seletHyd || !v.dataset.src) return;
    v.__seletHyd = true;
    v.src = v.dataset.src;
    v.preload = 'metadata';
  }
  function setup(v) {
    if (v.__seletSetup) return;
    v.__seletSetup = true;
    /* o tema chama video.play() ao trocar de slide: garante a src antes */
    var nativePlay = v.play;
    v.play = function () { hyd(v); var p = nativePlay.call(v); if (p && p.catch) p.catch(function () {}); return p; };
    v.addEventListener('pointerdown', function () { hyd(v); }, { passive: true });
    if (!('IntersectionObserver' in window)) { hyd(v); return; }
    var auto = v.hasAttribute('data-selet-autoplay');
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > 0.25) {
          hyd(v);
          if (auto && v.paused) { v.muted = true; v.play(); }
        } else if (auto && !v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.25, 0.6] }).observe(v);
  }
  function init() { document.querySelectorAll('video.selet-lazy-video').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
